import { render } from "./CourseCertificate.vue?vue&type=template&id=07d249f1&scoped=true"
import script from "./CourseCertificate.vue?vue&type=script&lang=js"
export * from "./CourseCertificate.vue?vue&type=script&lang=js"

import "./CourseCertificate.vue?vue&type=style&index=0&id=07d249f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d249f1"]])

export default __exports__